import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { NotificationAlert } from '@/graphql/queries/notifications.queries'
import { NotifiableType } from '@/graphql/subscriptions/notifications.subscriptions'
import { useGuardedNavigate } from '@/hooks/useGuardedNavigate'

import { notificationPath } from './NotificationAlerts.data'

type Props = {
  handleMarkNotification: (notifiableId: number, notifiableType: NotifiableType) => void
  notification: NotificationAlert
}

export const MobileNotifications = ({ notification, handleMarkNotification }: Props) => {
  const navigate = useGuardedNavigate()
  const { message, notifiableId, notifiableType, createdAt, viewedAt } = notification
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const time = formatInTimeZone(createdAt, timezone, 'yyyy-MM-dd, h:mmaaa')
  const routePath = notificationPath(notification)

  function routeToNotification() {
    if (!viewedAt) handleMarkNotification(notifiableId, notifiableType)
    navigate(routePath)
  }

  return (
    <div
      className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md"
      onClick={() => routeToNotification()}
      role={'presentation'}
    >
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm" style={{ fontWeight: 'bold' }}>
          {message}
        </p>
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Created At</p>
        <p className="ml-3 flex-1 text-right font-bold text-sm">{time}</p>
      </div>
    </div>
  )
}
